/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import Loader from "../../../components/Loader/Index";
import { getFeatures } from "../../../redux/features/Settings/Management/Features";

import accountNameStandardised from "../../../utils/accountNamestandardised";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import ICONS from "../../../assets/Icons";

export default function FeaturesViewAll() {
  const { allFeaturesData, allFeaturesIsLoading } = useSelector(
    (x) => x.featuresSlice,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [active, setActive] = useState("");
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[GlobalConfiguration.lengthCheckZero],
    });

  const [searchString, setSearchString] = useState(
    searchParam.get("search") || "",
  );
  const [sortOption] = useState(searchParam.get("sort") || "");
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );

  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  useEffect(() => {
    (async () => {
      await dispatch(
        getFeatures({
          page_no: currentPage,
          page_size: pageSize,
          search_string: searchString,
        }),
      );
    })();
  }, [searchString, pageSize, currentPage]);

  const unbinnedFeatures = allFeaturesData?.features ?? [];

  useEffect(() => {
    switch (active) {
      case "search":
      default:
      // setSearchString(searchText);
    }
  }, [active]);

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleClearParams = (e) => {
    handleClearSearchParam();

    if (showInnerSearchBar) return;
    setSearchString("");
    setSearchText("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  function binFeatures(features) {
    let accumulator;
    for (let {
      feature_id,
      feature_name,
      feature_description,
      feature_header,
    } of features) {
      let packedFeature = { feature_id, feature_name, feature_description };
      if (!Array.isArray(accumulator?.[feature_header])) {
        accumulator = { ...accumulator, [feature_header]: [packedFeature] };
      } else {
        accumulator[feature_header].push(packedFeature);
      }
    }
    return accumulator;
  }

  return false ? (
    <>
      <div className="fixed top-top-base left-left-base w-screen h-screen flex flex-col items-center justify-center z-z-index-loader">
        <div className="h-navbar-breadcrumb-height Qmd:block hidden"></div>
        <div>
          <Loader type={"bulk_upload"} />
        </div>
      </div>
    </>
  ) : (
    <div className="h-full-height flex flex-col overflow-y-hidden bg">
      {showInnerSearchBar && (
        <div className="features-curtain-div-page h-full-height w-full-width fixed bg-PopUp-BackDrop opacity-dark-opacity z-z-index-overlay"></div>
      )}
      <>
        {
          <div
            style={{
              zIndex: showInnerSearchBar
                ? "var(--z-index-max)"
                : "var(--z-index-max)",
              width: "var(--width-full)",
              bottom: "var(--bottom-base)",
            }}
            className="fixed w-full bg-primary-nav"
          >
            {showInnerSearchBar && (
              <div className="features-curtain-div-page h-full-height w-full-width fixed bg-PopUp-BackDrop opacity-dark-opacity z-z-index-overlay"></div>
            )}
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={allFeaturesData ?? []}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={(e) => {}}
            />
          </div>
        }
        <div className="relative z-z-index-overlay">
          <div className="h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav"></div>

          <TopNavComponent
            selectionBtnProps={{
              btnText: "Hello",
              btnType: "button",
              handleFunction: (e) => {},
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              disabledTextColor: "",
              enabledBgColor: "var(--primary-bg)",
              disabledBgColor: null,
              isLoading: false,
              outLineColor: null,
              icon: ICONS?.EDIT,
            }}
            filteredSearchProps={{
              onSearchInput: (e) => setSearchText(e),
              searchInputRef: null,
              searchText: searchText,
              searchPlaceholder: "Search by feature name / feature description",
              filterPlaceholder: "feature",
              isSearchDisabled: false,
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchString,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchString(val);
                  },
                  isDropdown: false,
                  isDisabled: false,
                },
              ],
              loading: allFeaturesIsLoading,
              isSortDisabled: allFeaturesIsLoading,
              isFilterDisabled: allFeaturesIsLoading,

              inputData: [],
              setShowInnerSearchBar: setShowInnerSearchBar,
              setActive: setActive,
              isShowFilter: false,
              // isShowSortBy: true,
              filters: null,
              showSearchBar: false,
              isFilterClearAllDisabled: null,
              isSearchClearAllDisabled: null,
              sortValue: sortOption,
              sortHandleChange: (e) => {},
              sortByFilter: [
                {
                  name: "Alphabetical : A to Z",
                  default: true,
                  isDisabled: false,
                },
                {
                  name: "Alphabetical : Z to A",
                  isDisabled: false,
                },
                {
                  name: "Order : Latest",
                  isDisabled: false,
                },
                {
                  name: "Order : Oldest",
                  isDisabled: false,
                },
              ],
              active: active,
            }}
          />
        </div>
        {allFeaturesIsLoading ? (
          <>
            <div className="fixed top-top-base left-left-base w-screen h-screen flex flex-col items-center justify-center z-z-index-loader">
              <div className="h-navbar-breadcrumb-height Qmd:block hidden"></div>
              <div>
                <Loader type={"bulk_upload"} />
              </div>
            </div>
          </>
        ) : unbinnedFeatures.length ? (
          <div
            className={`${showInnerSearchBar ? "overflow-y-hidden" : "overflow-y-scroll"}  mb-[var(--pagination-height)] py-padding-md relative flex-1 z-z-index-content scroll-py-top_md`}
          >
            <div className="flex flex-col gap-gap-md px-mobile-padding-l Qsmd:px-padding-md pt-padding-base overflow-y-visible">
              {Object.entries(binFeatures(unbinnedFeatures)).map(
                ([header, value]) => {
                  return (
                    <>
                      <div className="flex flex-col gap-gap-sm">
                        <h1 className="standard-setting-card-alignment gap-gap-md font-semibold text-text-primary text-font-md truncate">
                          {accountNameStandardised(header)}
                        </h1>
                        <div className="standard-setting-card-alignment gap-gap-md">
                          {value.map(
                            ({
                              feature_id,
                              feature_name,
                              feature_description,
                            }) => {
                              return (
                                <CardContainer
                                  cardBgColor="primary-card"
                                  context={feature_id}
                                  onClickHandler={(e, c) => {
                                    const isViewAll =
                                      location.pathname.includes(
                                        `settings/feature_view_all`,
                                      );

                                    navigate(`feature_detail_page/${c}`, {
                                      state: { isViewAll },
                                    });
                                  }}
                                >
                                  <card-body>
                                    <TextWithIcon
                                      text={feature_name}
                                      textColor="var(--text-primary)"
                                      subText="Feature name"
                                    />
                                    <TextWithIcon
                                      text={feature_description}
                                      textColor="var(--text-primary)"
                                      subText="Feature description"
                                    />
                                  </card-body>
                                </CardContainer>
                              );
                            },
                          )}
                        </div>
                      </div>
                    </>
                  );
                },
              )}
            </div>
          </div>
        ) : (
          <>
            <div
              className={
                showInnerSearchBar
                  ? `h-height-full  opacity-dark-opacity flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                  : `flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl h-height-full gap-gap-sm ${
                      false ? "h-auto" : ""
                    }`
              }
            >
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt="No accounts found"
                className={"w-graphic-width-md h-graphic-rectangle-height-md"}
              />
              <p className={"text-font-sm text-text-primary items-center"}>
                No data found.
              </p>
              <div
                style={{
                  display: searchString ? "flex" : "none",
                }}
              >
                <PrimaryButton
                  isDisabled={showInnerSearchBar}
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={handleClearParams}
                  buttonRef={null}
                  hoverOption="white"
                />
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
}
